<script>
    import axios from "axios";
    import { createEventDispatcher } from "svelte";

    let dispatch = createEventDispatcher();

    export let user;

    let password = "";
    let passwordRepeat = "";

    function changePassword() {
        if (password !== passwordRepeat) return;

        return axios
            .put(
                `/api/admin/user${user.id ? "?userId=" + user.id : ""}`,
                {
                    email: user.email,
                    password: password,
                    username: user.username,
                },
                {
                    headers: {
                        Authorization:
                            "Bearer " + window.localStorage.getItem("token"),
                        "Content-Type": "application/json",
                    },
                }
            )
            .then((response) => {
                if (response.status === 200) {
                    dispatch("close");
                }
            });
    }

    function cancel() {
        password = "";
        passwordRepeat = "";
        dispatch("close");
    }
</script>

<form class="modal">
    <label for="password" class="text-l">Neues Passwort</label>
    <input
        type="password"
        name="password"
        id="password"
        bind:value={password}
    />

    <label for="passwordRepeat" class="text-l">Passwort wiederholen</label>
    <input
        type="password"
        name="passwordRepeat"
        id="passwordRepeat"
        bind:value={passwordRepeat}
    />
    <button on:click={() => changePassword()}> Passwort ändern </button>

    <button on:click={() => cancel()}> Abbrechen </button>
</form>

<style>
    .modal {
        position: absolute;
        top: 33%;
        left: 33%;
        right: 33%;
        bottom: 33%;

        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        background-color: var(--white-100);
        border-radius: 8px;
        border: 1px solid var(--black-100);
    }
</style>
